import { Case, CaseStatuses, OrderStatuses } from "@types-runway/case";

export enum OrderPaymentState {
  NOT_APPLICABLE = "notApplicable",
  PAYMENT_FAILED = "paymentFailed",
  PAID = "paid",
  IN_FULFILLMENT = "inFulfillment",
  UNKNOWN = "unknown",
}

export const deriveOrderPaymentState = (case_: Case): OrderPaymentState => {
  const order = case_.CurexaOrder;
  const isCancelled =
    case_.case_status === CaseStatuses.CANCELLED || order?.status === OrderStatuses.CANCELLED;

  if (!order || order.id == null || case_.case_status !== CaseStatuses.COMPLETED || isCancelled) {
    return OrderPaymentState.NOT_APPLICABLE;
  }
  if (order.status) {
    return OrderPaymentState.IN_FULFILLMENT;
  }
  if (order.paid === true) {
    return OrderPaymentState.PAID;
  }
  if (order.paid === false) {
    return OrderPaymentState.PAYMENT_FAILED;
  }

  return OrderPaymentState.UNKNOWN;
};
